export default "__VITE_ASSET__ff28AzjK__"